import React from "react";
import { Button, Tooltip } from "antd";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import {
  loadPage,
  deleteEvents,
} from "../../features/scheduling/schedulingSlice";
import moment from "moment";
import { DeleteOutlined } from "@ant-design/icons";

const DeleteEventsButton = ({ events, currentDate }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const deleteLoading = useSelector(
    (state) => state.pendingActions["scheduling/delete_events"]
  );
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const handleDeleteEvents = async () => {
    const params = {
      branchId: activePatient.branch,
      patientId: activePatient.id,
      events: { events: events.map((i) => i.id) },
    };
    await dispatch(deleteEvents(params));
    reload();
  };

  const reload = async () => {
    const startDate = moment(currentDate).startOf("month");
    var endDate = moment(currentDate).endOf("month");
    if (activePatient) {
      await dispatch(
        loadPage({
          query: {
            from: moment.utc(startDate).format(),
            to: moment.utc(endDate).format(),
          },
        })
      );
    }
  };

  return (
    <Tooltip
      title={intl.formatMessage({ id: "app.scheduling.deleteExcessEvents" })}
      key={"warning"}
      color={"red"}
    >
      <Button
        type="text"
        danger
        icon={<DeleteOutlined />}
        onClick={handleDeleteEvents}
        loading={deleteLoading}
      />
    </Tooltip>
  );
};

export default DeleteEventsButton;
